export var SENTRY_RELEASE = "c2f2e7e18902f391d574fa287658bfbcb3ca7f9b";
